"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SlidingMarker_1 = __importDefault(require("./SlidingMarker/SlidingMarker"));
exports.DriftMarker = SlidingMarker_1.default;
const Sliding_Marker_1 = __importDefault(require("./SlidingMarker/Sliding_Marker"));
exports.Drift_Marker = Sliding_Marker_1.default;
//# sourceMappingURL=index.js.map